<div class="timeline-box">
  <div class="timeline-header">
    <h1>Detalles de la consulta</h1>
    <button
      class="btn absolute flex h-[41px] w-[41px] rounded-full border bg-white shadow-md transition-all hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:shadow-gray-950 dark:hover:bg-gray-600 fixed right-4 max-md:bottom-[calc(50%-26px)] md:bottom-36 lg:right-10"
      (click)="toggleSidebar()">
      <svg
        class="btn-box"
        *ngIf="!this.isSidebarCollapsed"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 15l-7-7-7 7"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <svg
        class="btn-box"
        *ngIf="this.isSidebarCollapsed"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 9l7 7 7-7"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </div>
  <div class="timeline" *ngIf="!this.collapsed">
    <div
      class="timeline-step"
      *ngFor="let etapa of etapas"
      [ngClass]="{
        completed: estado?.includes(etapa.key),
        active: estado?.includes(etapa.key),
      }">
      <div class="circle"></div>
      <span>{{ etapa.label }}</span>
    </div>
  </div>
</div>
